<style scoped>
    .complete {
        background: #DDF2BB;
        max-height: 2em !important;
        overflow: hidden;

    }

    .incomplete {
        background: #F39797;
        max-height: 2em !important;
        overflow: hidden;
    }

    .v-list__tile__title {
        height: 2.5em;
    }

    .v-list__tile__title a {
        max-height: 2.5em;
    }

    .list > li.complete > a {
        background: plum;
    }
   
    .incomplete > .v-list__tile.v-list__tile--link.v-list__tile--active.primary--text > .v-list__tile__content{
        color: black !important;
        font-weight: bolder !important;
    }

     .complete > .v-list__tile.v-list__tile--link.v-list__tile--active.primary--text > .v-list__tile__content{
        color: black !important;
        font-weight: bolder !important;
    }

</style>

<template >
    <v-list v-model="selectedClassId">
      <v-subheader>Classes</v-subheader>
      <v-list-tile
      v-bind:class="{ 'complete': classItem.isComplete, 'incomplete': !classItem.isComplete }"
      v-bind:model="selectedClassId==classItem.id" v-for="classItem in classes" :key="classItem.Id" 
      @click="classSelected(classItem.id, classItem)"
      >
        <v-list-tile-content>
            <v-list-tile-title v-html="classItem.name"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    
</template>
<script>
    import { getClassesForTeacher, getClassesForMiddleManager } from '../utils/effort-tracking-api';
    
    export default {
        name:  'teacher-classes',
        props: [ 'teacherId', 'value', 'period' ],
        data () {
            return {
                classes: [],
                selectedClassId: '0',
                middleManagerId: 0
            }
        },
        watch: {
            selectedClassId: function(val) {
            },
            teacherId: function(val) {                
                this.update();
            }
            
        },
        methods: {
            classSelected(classId, selectedPeriodClassID){
                this.selectedClassId = classId;
                this.selectedPeriodClassID = selectedPeriodClassID;
                this.$emit('input', classId, selectedPeriodClassID);
            },
            update() {
                var managerId = this.$route.params.middleManagerId;
                if (managerId === undefined)
                {
                    managerId = localStorage.getItem('middlemanagerid');
                }

                if(managerId != "undefined" && managerId !== null && managerId !== this.teacherId)
                {
                    var middleManagerId = Number(managerId);
                    getClassesForMiddleManager(middleManagerId, this.$route.params.teacherId).then(classes => {
                        this.$store.state.teacherClasses = classes;
                        this.classes = classes;
                    });

                } else {
                    getClassesForTeacher(this.$route.params.teacherId).then((classes) => {
                        this.$store.state.teacherClasses = classes;
                        this.classes = classes;
                    });  
                }
            },
            refresh(data, classId) {
                var _class = this.$store.state.teacherClasses.filter(tc => tc.id == classId)[0];
                var incompleteGrades = this.$store.state.classStudents.filter(cs => cs.incompleteGrades != 0);
                _class.isComplete = (incompleteGrades.length == 0 ) ? true : false;
            }
        },
        mounted() {
            var managerId = this.$route.params.middleManagerId;
            if(managerId !== undefined)
                localStorage.setItem('middlemanagerid', managerId);

            this.update();
        },

    }
</script>

<style>
    .complete > .list__tile {
        max-height: 2em !important;
    }

    .incomplete > .list__tile {
        max-height: 2em !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/TeacherClassesList.vue